import image_logo from "../../assets/images/logo.svg";
import {
    PROVIDER,
    OPERATOR,
    controllerLine,
    providerRoleSentence,
} from "../../config/legalEntities";

function TermsAndConditionsDriver() {
    const appName = process.env.REACT_APP_NAME || "TruHail";
    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 py-10">
            <div className="mb-8 h-[80px] overflow-hidden rounded-2xl">
                <img
                    src={image_logo}
                    alt={`Logo ${appName}`}
                    height={80}
                    className="h-full w-full object-cover"
                />
            </div>

            <div className="mx-auto max-w-3xl rounded-2xl bg-white p-6 shadow-md">
                <h1 className="mb-4 text-2xl font-bold">
                    Termos e Condições de Uso — Motoristas
                </h1>
                <p className="mb-6 text-sm text-gray-500">
                    Última atualização: 26 de fevereiro de 2026
                </p>
                <p className="mb-8 text-lg">
                    Estes Termos e Condições (&quot;Termos&quot;) regulam o uso do
                    aplicativo {appName} por você, na qualidade de Motorista. Ao
                    cadastrar-se ou utilizar o aplicativo, você declara ter lido,
                    compreendido e concordado integralmente com estes Termos.
                </p>

                <div className="space-y-8">
                    {/* 1. Definições */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">1. Definições</h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                <strong>&quot;Provedora da Plataforma&quot;</strong>:{" "}
                                {PROVIDER.name} (CNPJ {PROVIDER.cnpj}), empresa responsável
                                pelo desenvolvimento e manutenção da infraestrutura
                                tecnológica do aplicativo. A Provedora não é Controladora dos
                                dados pessoais de Motoristas e Passageiros. {providerRoleSentence}
                            </li>
                            <li>
                                <strong>&quot;Operadora&quot;</strong>: {controllerLine},
                                empresa ou pessoa física que licencia e opera o aplicativo sob
                                marca própria (whitelabel), sendo responsável pela gestão do
                                serviço junto a Motoristas e Passageiros e atuando como
                                Controladora dos respectivos dados pessoais.
                            </li>
                            <li>
                                <strong>&quot;Plataforma&quot;</strong>: o aplicativo móvel{" "}
                                {appName} e todos os serviços e sistemas associados.
                            </li>
                            <li>
                                <strong>&quot;Motorista&quot;</strong>: pessoa física cadastrada
                                na Plataforma como prestadora de serviço de transporte
                                individual de passageiros.
                            </li>
                            <li>
                                <strong>&quot;Passageiro&quot;</strong>: pessoa física cadastrada
                                no aplicativo para solicitar e utilizar corridas.
                            </li>
                            <li>
                                <strong>&quot;Serviço&quot;</strong>: intermediação tecnológica
                                entre Motoristas e Passageiros para realização de corridas.
                            </li>
                        </ul>
                    </div>

                    {/* 2. Aceite */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">2. Aceite dos Termos</h2>
                        <p>
                            Ao instalar, acessar ou utilizar a Plataforma, você concorda com
                            estes Termos e com a nossa{" "}
                            <a
                                href="/privacy-policy-driver"
                                className="text-blue-600 underline"
                            >
                                Política de Privacidade
                            </a>
                            . Caso não concorde, você deve cessar imediatamente o uso da
                            Plataforma.
                        </p>
                    </div>

                    {/* 3. Elegibilidade */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            3. Elegibilidade e Cadastro
                        </h2>
                        <p className="mb-2">
                            Para utilizar a Plataforma como Motorista, você deve:
                        </p>
                        <ul className="list-inside list-disc space-y-1">
                            <li>Possuir idade mínima de 21 (vinte e um) anos</li>
                            <li>
                                Possuir CNH (Carteira Nacional de Habilitação) válida, na
                                categoria adequada e sem restrições impeditivas
                            </li>
                            <li>
                                Fornecer documentos pessoais e do veículo: foto de perfil, dados
                                completos do veículo (placa, modelo, ano, cor), CNH, CRLV e
                                certidões de antecedentes criminais
                            </li>
                            <li>
                                Declarar que o veículo possui seguro obrigatório (DPVAT ou
                                equivalente) e está em condições adequadas de uso
                            </li>
                            <li>
                                Manter todos os documentos atualizados durante todo o período de
                                uso da Plataforma
                            </li>
                            <li>
                                Submeter-se ao processo de aprovação pela Operadora antes de
                                poder oferecer corridas
                            </li>
                        </ul>
                    </div>

                    {/* 4. Natureza da Relação */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            4. Natureza da Relação
                        </h2>
                        <p>
                            O Motorista atua como <strong>profissional autônomo</strong>. A
                            utilização da Plataforma não cria vínculo empregatício entre o
                            Motorista e a Provedora da Plataforma ou a Operadora. O Motorista
                            é livre para determinar seus horários e decidir quais corridas
                            aceitar.
                        </p>
                    </div>

                    {/* 5. Descrição do Serviço */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            5. Descrição do Serviço
                        </h2>
                        <p className="mb-2">
                            A Plataforma oferece as seguintes funcionalidades ao Motorista:
                        </p>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                Visualização e recebimento automático de solicitações de corrida
                                por passageiros
                            </li>
                            <li>Envio de proposta de valor ao passageiro</li>
                            <li>Gestão de corridas aceitas com navegação integrada</li>
                            <li>
                                Carteira digital com controle de comissão em cada corrida
                            </li>
                            <li>
                                Repasses financeiros para conta bancária ou conta do provedor de
                                pagamento cadastrada
                            </li>
                            <li>Histórico de corridas e avaliações recebidas</li>
                        </ul>
                    </div>

                    {/* 6. Obrigações do Motorista */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            6. Obrigações do Motorista
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                Manter documentos pessoais e do veículo atualizados e válidos
                            </li>
                            <li>
                                Não utilizar o aplicativo de maneira que comprometa a segurança
                                na condução (exceto sistemas hands-free permitidos por lei)
                            </li>
                            <li>
                                Atender aos padrões de qualidade e segurança estabelecidos pela
                                Plataforma e pela Operadora
                            </li>
                            <li>
                                Tratar passageiros com respeito, educação e profissionalismo
                            </li>
                            <li>
                                Zelar pela manutenção e limpeza do veículo utilizado para
                                prestação do serviço
                            </li>
                            <li>
                                Não compartilhar dados pessoais dos passageiros obtidos durante
                                corridas com terceiros
                            </li>
                            <li>
                                Cumprir todas as leis de trânsito e regulamentações aplicáveis
                                ao transporte de passageiros
                            </li>
                            <li>
                                Possuir seguro de responsabilidade civil para transporte de
                                passageiros, conforme exigido pela legislação local
                            </li>
                        </ul>
                    </div>

                    {/* 7. Pagamentos e Comissões */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            7. Pagamentos e Comissões
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                Os valores das corridas são calculados pela Plataforma com base
                                em distância, duração, categoria do veículo e demanda
                            </li>
                            <li>
                                Uma comissão será retida sobre cada corrida realizada, conforme
                                percentual definido pela Operadora e sempre informado
                                previamente
                            </li>
                            <li>
                                Os valores acumulados na carteira digital podem ser sacados de
                                acordo com as regras estabelecidas pela Operadora
                            </li>
                            <li>
                                Repasses financeiros são processados por provedores de pagamento
                                terceirizados (vide{" "}
                                <a
                                    href="/privacy-policy-driver"
                                    className="text-blue-600 underline"
                                >
                                    Política de Privacidade
                                </a>
                                )
                            </li>
                            <li>
                                A Plataforma ou Operadora reserva-se o direito de alterar taxas
                                e comissões com prévia comunicação de pelo menos 30 (trinta)
                                dias
                            </li>
                            <li>
                                Taxas de serviço podem ser divididas entre a Provedora da
                                Plataforma, a Operadora e o Motorista, conforme contrato
                                vigente
                            </li>
                        </ul>
                    </div>

                    {/* 8. Cancelamentos e Disputas */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            8. Cancelamentos e Disputas
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                O Motorista pode cancelar corridas aceitas dentro do período de
                                cancelamento gratuito sem penalidades
                            </li>
                            <li>
                                Cancelamentos recorrentes podem afetar a classificação do
                                Motorista e resultar em suspensão temporária
                            </li>
                            <li>
                                Disputas devem ser reportadas pela Plataforma e serão analisadas
                                pela Operadora
                            </li>
                            <li>
                                O Motorista compromete-se a cooperar com investigações de
                                incidentes ou reclamações
                            </li>
                        </ul>
                    </div>

                    {/* 9. Propriedade Intelectual */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            9. Propriedade Intelectual
                        </h2>
                        <p>
                            Todos os direitos sobre o software, marcas, logotipos, interfaces,
                            algoritmos e conteúdos da Plataforma pertencem à Provedora da
                            Plataforma e/ou à Operadora, conforme aplicável. É vedada a
                            reprodução, modificação, engenharia reversa, distribuição ou uso
                            comercial não autorizado de qualquer parte da Plataforma.
                        </p>
                    </div>

                    {/* 10. Limitação de Responsabilidade */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            10. Limitação de Responsabilidade
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                A <strong>Provedora da Plataforma</strong> fornece a
                                infraestrutura tecnológica &quot;como está&quot; (as is) e não
                                se responsabiliza por danos diretos, indiretos, incidentais ou
                                consequenciais decorrentes da prestação do serviço de transporte
                            </li>
                            <li>
                                A <strong>Operadora</strong> é responsável pela gestão e suporte
                                ao Motorista dentro do escopo do Serviço oferecido
                            </li>
                            <li>
                                O Motorista é o único responsável por acidentes, infrações de
                                trânsito, danos a passageiros ou terceiros durante a prestação
                                do serviço de transporte
                            </li>
                            <li>
                                A Plataforma não garante um volume mínimo de corridas ou
                                faturamento
                            </li>
                        </ul>
                    </div>

                    {/* 11. Indenização */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">11. Indenização</h2>
                        <p>
                            O Motorista concorda em indenizar e isentar a Provedora da
                            Plataforma, a Operadora, seus diretores, funcionários e parceiros
                            de quaisquer reclamações, danos, perdas ou despesas (incluindo
                            honorários advocatícios) decorrentes do uso indevido da
                            Plataforma, violação destes Termos ou da prestação do serviço de
                            transporte.
                        </p>
                    </div>

                    {/* 12. Suspensão e Encerramento */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            12. Suspensão e Encerramento de Conta
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                A Plataforma reserva-se o direito de suspender ou encerrar
                                contas por comportamento inadequado, documentação expirada,
                                avaliações baixas ou violação destes Termos
                            </li>
                            <li>
                                O Motorista pode solicitar o encerramento de sua conta a
                                qualquer momento, sujeito à conclusão de corridas pendentes e
                                liquidação de valores devidos
                            </li>
                            <li>
                                A verificação de documentos pode ser realizada através de
                                serviços terceiros autorizados
                            </li>
                            <li>
                                Dados pessoais serão tratados conforme a Política de Privacidade
                                e legislação de proteção de dados, mesmo após o encerramento
                            </li>
                        </ul>
                    </div>

                    {/* 13. Legislação e Foro */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            13. Legislação Aplicável e Foro
                        </h2>
                        <p>
                            Estes Termos são regidos pelas leis de proteção de dados,
                            legislação trabalhista e regulamentação de transporte aplicáveis na
                            jurisdição da Operadora. Eventuais litígios serão submetidos ao
                            foro competente da comarca do domicílio do Motorista, conforme
                            legislação aplicável.
                        </p>
                    </div>

                    {/* 14. Alterações */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            14. Alterações dos Termos
                        </h2>
                        <p>
                            A Provedora da Plataforma e/ou a Operadora reservam-se o direito
                            de alterar estes Termos a qualquer momento. Alterações relevantes
                            serão comunicadas pelo aplicativo, e-mail ou outros canais
                            disponíveis, com antecedência mínima de 30 (trinta) dias para
                            questões financeiras. O uso continuado da Plataforma após a
                            notificação constitui aceite das alterações.
                        </p>
                    </div>

                    {/* 15. Provedores e Subprocessadores */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            15. Provedores e Subprocessadores
                        </h2>
                        <p className="mb-2">
                            Para operar a Plataforma, compartilhamos dados pessoais
                            estritamente necessários com provedores terceiros
                            (subprocessadores), que os tratam exclusivamente para a
                            finalidade de prestação dos respectivos serviços. Cada provedor
                            possui sua própria política de termos e privacidade, que recomendamos
                            consultar:
                        </p>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                <strong>Mercado Pago</strong> (processamento de pagamentos e
                                repasses) —{" "}
                                <a
                                    href="https://www.mercadopago.com.br/ajuda/termos-e-politicas_194"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos e políticas
                                </a>
                            </li>
                            <li>
                                <strong>OneSignal</strong> (notificações push) —{" "}
                                <a
                                    href="https://onesignal.com/tos"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos de serviço
                                </a>
                            </li>
                            <li>
                                <strong>SendPulse</strong> (envio de e-mails e mensagens) —{" "}
                                <a
                                    href="https://sendpulse.com/legal/termsofservice"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos de serviço
                                </a>
                            </li>
                            <li>
                                <strong>OpenStreetMap</strong> (dados de mapas) —{" "}
                                <a
                                    href="https://operations.osmfoundation.org/policies/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Políticas
                                </a>
                            </li>
                            <li>
                                <strong>CARTO</strong> (serviços de geolocalização e mapas) —{" "}
                                <a
                                    href="https://carto.com/legal"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos legais
                                </a>
                            </li>
                            <li>
                                <strong>Firebase / Google</strong> (infraestrutura e serviços de
                                back-end) —{" "}
                                <a
                                    href="https://firebase.google.com/terms"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos
                                </a>
                            </li>
                            <li>
                                <strong>Apple App Store</strong> (distribuição do aplicativo) —{" "}
                                <a
                                    href="https://www.apple.com/legal/internet-services/itunes/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos
                                </a>
                            </li>
                            <li>
                                <strong>Google Play</strong> (distribuição do aplicativo) —{" "}
                                <a
                                    href="https://play.google.com/about/play-terms/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos
                                </a>
                            </li>
                        </ul>
                        <p className="mt-2 text-sm text-gray-500">
                            As URLs e versões das políticas de terceiros podem mudar; confira na
                            data de acesso. Para exercício de direitos relativos aos seus dados
                            pessoais, entre em contato com o nosso Encarregado de Proteção de
                            Dados (DPO):{" "}
                            <a
                                href="mailto:dpo@trusom.com"
                                className="text-blue-600 underline"
                            >
                                dpo@trusom.com
                            </a>
                            .
                        </p>
                    </div>

                    {/* 16. Contato */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">16. Contato</h2>
                        <p>
                            Para dúvidas sobre estes Termos, entre em contato:{" "}
                            <a
                                href="mailto:software@trusom.com"
                                className="text-blue-600 underline"
                            >
                                software@trusom.com
                            </a>
                        </p>
                        <p className="mt-2">
                            Para questões sobre proteção de dados:{" "}
                            <a
                                href="mailto:dpo@trusom.com"
                                className="text-blue-600 underline"
                            >
                                dpo@trusom.com
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TermsAndConditionsDriver;
